import intersection from 'lodash.intersection';

const getIntersectedProp = (rangeQueryValues, propsToDisplay) =>
  intersection(Object.keys(rangeQueryValues), propsToDisplay)[0];

export default getIntersectedProp;
